import tokenHttpClient from "../utils/httpClient";
import { post } from "../utils/httpClient-methods";
import { VENDOR_API_URL, BASE_URL_MASTERS } from "../utils/AppApiUrl";

export const VendorListingService = async (requestBody) => {
  try {
    const vendorListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: requestBody?.filterSearch ?? null,
      sortBy: requestBody?.sortBy,
      sortDirection: requestBody?.sortDirection,
    };
    const vendorListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${VENDOR_API_URL.vendorListing}`,
      vendorListingRequestObj
    );
    // add condition here to check
    if (vendorListingResponse.status === 200) {
      return vendorListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const VendorListingSearchService = async (requestBody, searchValue) => {
  try {
    const vendorListingRequestObj = {
      active: requestBody?.active,
      pageNumber: requestBody?.pageNumber,
      pageSize: requestBody?.pageSize,
      filterSearch: searchValue,
      sortBy: requestBody?.sortBy,
      sortDirection: "ASC",
    };
    const vendorListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${VENDOR_API_URL.vendorListing}`,
      vendorListingRequestObj
    );
    // add condition here to check
    if (vendorListingResponse.status === 200) {
      return vendorListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const VendorChangeStatusService = async (requestBody) => {
  try {
    const vendorStatusResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${VENDOR_API_URL.vendorChangeStatus}`,
      requestBody
    );
    // add condition here to check
    if (vendorStatusResponse.status === 200) {
      return vendorStatusResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const VendorAndSupplierTypeListingService = async () => {
  try {
    const typeListingResponse = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${VENDOR_API_URL.vendorAndSupplierTypeListing}`,
      null
    );
    // add condition here to check
    if (typeListingResponse.status === 200) {
      return typeListingResponse;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const onAddSupplierAndVendorService = async (values) => {
  try {
    const requestBody = {
      code: values?.code ?? "",
      name: values?.name ?? "",
      typeId: values && values.typeId ? parseInt(values.typeId) : null,
      repair: values?.repair ?? false,
      active: values && values.active === "false" ? false : true,
      createdOn: values?.createdOn,
      createdBy: values?.createdBy,
      modifiedOn: values?.modifiedOn,
      modifiedBy: values?.modifiedBy,
    };
    const saveVendorDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${VENDOR_API_URL.saveVendorDetails}`,
      requestBody
    );
    if (saveVendorDetails.status === 200) {
      return saveVendorDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const onEditSupplierAndVendorService = async (values, vendorId) => {
  try {
    const supplierVendorRequest = {
      code: values?.code ?? "",
      name: values?.name ?? "",
      typeId: values && values.typeId ? parseInt(values.typeId) : null,
      repair: values?.repair ?? false,
      active: values && values.active === false ? false : true,
      typeName: values?.typeName ?? "",
      createdOn: values?.createdOn,
      createdBy: values?.createdBy,
      modifiedOn: new Date(),
      modifiedBy: values?.modifiedBy,
    };
    const requestBody = {
      id: vendorId,
      supplierVendorRequest,
    };

    const editVendorDetails = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${VENDOR_API_URL.editVendorDetails}`,
      requestBody
    );
    if (editVendorDetails.status === 200) {
      return editVendorDetails;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
